module.exports = __webpack_public_path__ + "static/what-potato-b7c84ed62cd64d2f55dd9c10e4b0b6a3.jpg";